import { Tabs } from '@/components/common';
import Images from '@/const/images';
import clsx from 'clsx';
import * as React from 'react';
import {
	FieldError,
	FieldErrorsImpl,
	FieldValues,
	Merge,
	UseFormRegister,
	UseFormSetValue,
	UseFormWatch,
} from 'react-hook-form';
import { UploadNewTab } from './tabs/UploadNewTab';

type ConfigureDocumentTabId = 'upload-new' | 'select-previous';

const configureDocumentTabs: {
	name: ConfigureDocumentTabId;
	label: string;
	icon?: string;
	iconSrc?: string;
}[] = [
	{ name: 'upload-new', label: 'Upload New', iconSrc: Images.uploadCloud },
];

interface ConfigureDocumentTabsProps {
	file: File | null;
	setFile: React.Dispatch<React.SetStateAction<File | null>>;
	register: UseFormRegister<FieldValues>;
	setValue: UseFormSetValue<FieldValues>;
	watch: UseFormWatch<FieldValues>;
	documentNameError?:
		| FieldError
		| Merge<FieldError, FieldErrorsImpl<FieldValues>>;
	documentNameRules: Record<string, unknown>;
}

export const ConfigureDocumentTabs: React.FC<ConfigureDocumentTabsProps> = ({
	file,
	setFile,
	register,
	setValue,
	watch,
	documentNameError,
	documentNameRules,
}) => {
	const [activeTab, setActiveTab] =
		React.useState<ConfigureDocumentTabId>('upload-new');

	return (
		<div>
			<Tabs
				dataCY="configure-document"
				optionsTabs={configureDocumentTabs}
				currentOption={activeTab}
				setCurrentOption={(value) =>
					setActiveTab(value as ConfigureDocumentTabId)
				}
				inactiveTextClassName="text-opacity-black"
			/>

			<div
				role="tabpanel"
				aria-labelledby="tab-upload-new"
				className={clsx('space-y-3 mt-6', {
					hidden: activeTab !== 'upload-new',
				})}
			>
				<UploadNewTab
					file={file}
					setFile={setFile}
					register={register}
					setValue={setValue}
					watch={watch}
					documentNameError={documentNameError}
					documentNameRules={documentNameRules}
				/>
			</div>
		</div>
	);
};

export default ConfigureDocumentTabs;
